import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import OrderTrack from "@/pages/OrderTrack";
import Shipping from "@/pages/Shipping";
import Returns from "@/pages/Returns";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminOrders from "@/pages/AdminOrders";
import CartDrawer from "@/components/CartDrawer";
import Loader from "@/components/Loader";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/CartContext";
import { AdminAuthProvider } from "@/lib/AdminAuthContext";
import { ThemeProvider } from "@/lib/ThemeContext";
import { CursorGlow } from "@/lib/motion";

function App() {
  // Lenis smooth scroll
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <Loader />
        <CursorGlow />
        <AdminAuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<Success />} />
                <Route path="/orders/track" element={<OrderTrack />} />
                <Route path="/shipping" element={<Shipping />} />
                <Route path="/returns" element={<Returns />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
              </Routes>
              <CartDrawer />
            </BrowserRouter>
            <Toaster
              position="top-center"
              theme="dark"
              closeButton
              toastOptions={{
                className: "hr-toast",
                style: {
                  background:
                    "linear-gradient(135deg, rgba(16,8,38,0.95), rgba(8,4,18,0.95))",
                  border: "1px solid rgba(255,44,140,0.35)",
                  color: "#FFFFFF",
                  fontFamily: "'Sora', ui-sans-serif, system-ui, sans-serif",
                  fontSize: "13px",
                  letterSpacing: "0.02em",
                  boxShadow:
                    "0 10px 40px rgba(123,44,255,0.25), 0 0 24px rgba(255,44,140,0.18)",
                  backdropFilter: "blur(14px)",
                  borderRadius: "14px",
                  padding: "12px 14px",
                },
                classNames: {
                  success: "hr-toast-success",
                  error: "hr-toast-error",
                  info: "hr-toast-info",
                  warning: "hr-toast-warning",
                },
              }}
            />
          </CartProvider>
        </AdminAuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
